export {default as BaseComponent} from './base-component';

export * from './etc.js';
